module.exports = __webpack_public_path__ + "img/cultiver-bienveillance-emotions1.8e79a56f.jpg";